import Caver from 'caver-js';
import CURRENT_CHAIN from 'constants/chainInfo';

class Klaytn {
  private caver =
    (window as any).caver !== undefined
      ? window.caver
      : new Caver(CURRENT_CHAIN.rpcUrl);

  private contract = new this.caver.klay.Contract(
    CURRENT_CHAIN.contract.DEPLOYED_ABI,
    CURRENT_CHAIN.contract.DEPLOYED_ADDRESS,
  );

  public getBlockNumber = async () => {
    return this.caver === undefined
      ? -1
      : parseInt(await this.caver.rpc.klay.getBlockNumber(), 16);
  };

  public PublicMint = async (mintAmount: number) => {
    const account = (await window.klaytn.enable())[0];
    const mintPrice = (await this.getSalesInfo()).mintPrice;

    const gasAmount = await this.contract.methods
      .publicMint(mintAmount)
      .estimateGas({
        from: account,
        gas: 90000000,
        value: String(this.caver.utils.toPeb(mintPrice * mintAmount)),
      });

    const result = await this.contract.methods.publicMint(mintAmount).send({
      from: account,
      gas: gasAmount,
      value: String(this.caver.utils.toPeb(mintPrice * mintAmount)),
    });
    return result;
  };

  public FreeMint = async () => {
    const account = (await window.klaytn.enable())[0];

    const gasAmount = await this.contract.methods.freeMint().estimateGas({
      from: account,
      gas: 90000000,
    });

    const result = await this.contract.methods.freeMint().send({
      from: account,
      gas: gasAmount,
    });
    return result;
  };

  public getSalesInfo = async () => {
    const mintingInformation = await this.contract.methods
      .mintingInformation()
      .call();
    const name = await this.contract.methods.name().call();
    const symbol = await this.contract.methods.symbol().call();
    const isPublicMintEnabled = await this.contract.methods
      .publicMintEnabled()
      .call();

    return {
      name,
      symbol,
      mintIndexForSale: parseInt(mintingInformation[1]),
      mintLimitPerBlock: parseInt(mintingInformation[2]),
      mintLimitPerSale: parseInt(mintingInformation[3]),
      mintStartBlockNumber: parseInt(mintingInformation[4]),
      maxSaleAmount: parseInt(mintingInformation[5]),
      mintPrice: this.caver.utils.fromPeb(
        parseInt(mintingInformation[6]),
        'KLAY',
      ),
      isPublicMintEnabled,
    };
  };

  public getTokenInfo = async (tokenId) => {
    const tokenURI = await this.contract.methods.tokenURI(tokenId).call();
    return tokenURI;
  };
}

export default new Klaytn();
